import React, { useEffect, useState } from "react";
import { urls, currentLang } from "../../shared/seo/links";

export default function FloatButton() {
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    const ShowFloatButton = () => {
      if (
        window.location.pathname === "/Lawyer-Dashboard" ||
        window.location.pathname === "/User-Dashboard" ||
        window.location.pathname === "/register" ||
        window.location.pathname === "/login"
      ) {
        setShowButton(false);
      } else {
        setShowButton(true);
      }
    }
    ShowFloatButton()
  }, [window.location.pathname]);

  return showButton ? (
    <div className="float">
      <a href="/login" className="float">
        <i className="fa fa-user my-float"></i>
      </a>
    </div>
  ) : (
    <div className="float">
      <a href={urls.toHref(urls.lawyersPath(currentLang()))} className="float">
        <i className="fa fa-bookmark my-float"></i>
      </a>
    </div>
  );
}
